$(document).ready(function () {
  // Initialize Slick slider
  function initializeSlider() {
    $('.feature-slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 400,
      prevArrow: '<div class="slide-prev">...</div>',
      nextArrow: '<div class="slide-next">...</div>',
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      centerMode: false,
      adaptiveHeight: true,
      rtl: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true
          }
        }
      ]
    });
  }
});
